<template>
  <form class="py-12" v-on:submit.prevent="prevent">
    <v-slide-x-transition>
      <v-card class="mx-auto my-3" max-width="768">
        <!-- :loading="loading" -->
       <v-card-title v-if="!switchForm">
          {{ $t("register.steps.inventory.title") }}
        </v-card-title>
        <v-card-text>
          <v-alert type="info" outlined style="font-size: 1em" v-if="!switchForm">
            <div v-html="$t('register.steps.inventory.info')"></div>
          </v-alert>
          <div class="text-body-1 pb-2 pt-6 font-weight-bold black--text" v-if="!switchForm">
            {{ $t("register.steps.inventory.whereIventory") }}
          </div>
          <div class="text-body-1 pb-2 pt-6 font-weight-bold black--text" v-else>
            Enviar seu mídia kit
          </div>
          <div class="pb-2" v-show="!switchForm">
            <div class="d-flex flex-column">
              <v-checkbox
                class="font-weight-bold"
                v-model="into.marketplace"
                disabled
                :label="`Marketplace`"
                :hide-details="true"
              ></v-checkbox>
              <h5 class="caption font-weight-bold">
                {{ $t("register.steps.inventory.mrktPlaceInfo") }}
              </h5>
            </div>
            <div class="d-flex flex-column">
              <v-checkbox
                class="font-weight-bold"
                v-model="into.saas"
                disabled
                :label="`SaaS`"
                :hide-details="true"
              ></v-checkbox>
              <h5 class="caption font-weight-bold">
                {{ $t("register.steps.inventory.saasInfo") }}
              </h5>
            </div>
            <div class="d-flex flex-column">
              <v-checkbox
                class="font-weight-bold"
                v-model="into.whitelabel"
                :label="`White label`"
                :hide-details="true"
              ></v-checkbox> 
              <h5 v-if="into.whitelabel" class="caption red--text font-weight-bold">
                {{ $t("register.steps.inventory.whiteLabelDisclaimer") }} 
              </h5>
              <h5 class="caption font-weight-bold">
                {{ $t("register.steps.inventory.whiteLabelInfo") }} 
              </h5>
            </div>
          </div>
          <div
            class="text-body-1 pb-2 pt-6"
            :class="midiaKitErrors ? 'red--text' : ''"
            v-html="$t('register.steps.inventory.mediaKit')"
          ></div>
          <!-- <DropZone></DropZone> -->
          <FileUpload
            :target="`midia-kit/${hash}`"
            :error="midiaKitErrors"
            @set-upload="changeMidiaKit($event)"
          ></FileUpload>
          <div class="red--text text-caption" v-html="midiaKitErrors"></div>
          <div v-if="switchForm">
            Lembre-se que grandes marcas de diferentes segmentos estarão participando deste que é o maior evento de games na América Latina. Existem inúmeras possibilidades de encaixar seus formatos nos objetivos de divulgação de cada uma delas. Se não tiver algo para agora, não tem problema, o time de mídia da The Media Trade ficará feliz em ajudar nesse desenvolvimento com você.
          </div>
          <div v-if="switchForm" class="text-body-1 pb-2 pt-6 font-weight-bold black--text">
            Enviar apenas sua tabela de preços
          </div>
          <div
            class="text-body-1 pb-2 pt-6 d-flex"
            :class="priceTableErrors ? 'red--text' : ''"
          >
            <div v-html="$t('register.steps.inventory.priceTable')"></div>
            <v-tooltip bottom color="blue" max-width="340">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="blue"
                  dark
                  fab
                  x-small
                  elevation="0"
                  class="ml-3 xm-button"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-information-variant</v-icon>
                </v-btn>
              </template>
              <span
                v-html="$t('register.steps.inventory.priceTableInfo')"
              ></span>
            </v-tooltip>
          </div>
          <!-- <DropZone></DropZone> -->
          <FileUpload
            :target="`price-table/${hash}`"
            :error="priceTableErrors"
            @set-upload="changePriceTable($event)"
          ></FileUpload>
          <div class="red--text text-caption" v-html="priceTableErrors"></div>

          <v-row>
            <v-col style="padding-bottom: 0px;" cols="12" md="4" sm="12" class="d-flex align-center ">
              <!-- <v-switch v-model="form.net" 
                                :label="form.net ? $t('register.steps.inventory.netPrice') : $t('register.steps.inventory.grossPrice')">
                            </v-switch> -->
              <v-radio-group mandatory v-model="priceType">
                <div class="d-flex align-center">
                  <v-radio
                    :label="$t('register.steps.inventory.grossPrice')"
                    value="gross"
                  ></v-radio>
                  <v-tooltip bottom color="blue" max-width="340">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="blue"
                        dark
                        fab
                        x-small
                        class="ml-3 xm-button"
                        elevation="0"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-information-variant</v-icon>
                      </v-btn>
                    </template>

                    <span>{{
                      $t("register.steps.inventory.grossPriceInfo")
                    }}</span>
                  </v-tooltip>
                </div>
                <div class="d-flex align-center">
                  <v-radio
                    :label="$t('register.steps.inventory.netPrice')"
                    value="net"
                  ></v-radio>
                  <v-tooltip bottom color="blue" max-width="340">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="blue"
                        dark
                        fab
                        x-small
                        class="ml-3 xm-button"
                        elevation="0"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-information-variant</v-icon>
                      </v-btn>
                    </template>
                    <span
                      v-html="$t('register.steps.inventory.netPriceInfo')"
                    ></span>
                  </v-tooltip>
                </div>

              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col  style="position: relative; padding-top: 0px;">
              <v-text-field
                v-model="form.discount"
                type="number"
                :error-messages="discountErrors"
                :label="$t('register.steps.inventory.discount')"
                required
                @input="v$.form.discount.$touch()"
                @blur="v$.form.discount.$touch()"
                append-icon="mdi-percent-outline"
              ></v-text-field>
              <v-tooltip bottom color="blue" max-width="340">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue"
                    dark
                    x-small
                    fab
                    elevation="0"
                    class="ml-3 xm-button"
                    style="position: absolute; top: 0; right: 10px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-information-variant</v-icon>
                  </v-btn>
                </template>
                <span
                  v-html="$t('register.steps.inventory.discountInfo')"
                ></span>
              </v-tooltip>
            </v-col>
            <!-- <v-col>
                            <v-text-field v-model="form.commission" type="number" :error-messages="commissionErrors"
                                :label="$t('register.steps.inventory.commission')" required
                                @input="v$.form.commission.$touch()" @blur="v$.form.commission.$touch()"
                                append-icon="mdi-percent-outline"></v-text-field>
                        </v-col> -->
            <!-- <v-col v-if="!isBrazil">
                            <v-text-field v-model="form.tax" type="number" :label="$t('register.steps.inventory.tax')" required
                                :error-messages="taxErrors" @input="v$.form.tax.$touch()" @blur="v$.form.tax.$touch()"
                                append-icon="mdi-percent-outline"></v-text-field>
                        </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    required
                    :error-messages="dateErrors"
                    @input="v$.date.$touch()"
                    :label="$t('register.steps.inventory.valid')"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    @blur="date = parseDate(dateFormatted)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  @input="menu1 = false"
                  :min="disableDays"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-select
                v-model="form.frequency"
                :label="$t('register.steps.inventory.frequency')"
                :items="$t('register.steps.inventory.frequencyOptions')"
                required
                :error-messages="frequencyErrors"
                @input="v$.form.frequency.$touch()"
                @blur="v$.form.frequency.$touch()"
              >
              </v-select>
            </v-col>
          </v-row>
          <div v-if="switchForm" class="text-body-1 pb-2 pt-6 font-weight-bold black--text">
            Você já tem algum projeto especial para as marcas participantes da BGS anunciarem em seu veículo?
          </div>
          <div  v-if="switchForm">
            Exemplos de antes, durante e depois da BGS 2023: 1) uma marca convidar seus consumidores para visitar a feira; 2) anunciar que um produto/serviço que será lançado na feira; 3) impactar executivos da marca e ou decisores de mercado; 4) mostrar como foi a participação da marca na BGS 2023.
          </div>
          <div class="text-body-1 pt-6 pb-2 d-flex">
            <div v-html="$t('register.steps.inventory.complementary')"></div>
            <em class="ml-2" v-html="$t('common.optional_field')"></em>
          </div>
          <!-- <DropZone></DropZone> -->
          <FileUpload
            :target="`complementary/${hash}`"
            @set-upload="form.files.complementary = $event"
          >
          </FileUpload>
          <v-textarea
            v-model="form.info"
            counter="200"
            class="mt-6"
            width="100%"
            height="120"
            :label="`${$t('register.steps.inventory.description')} ${$t(
              'common.optional_field'
            )}`"
          >
          </v-textarea>
          <div v-if="switchForm">
            Ao clicar no botão "concluir", você estará concordando com os termos de uso da The Media Trade.
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end py-3">
          <div class="d-flex justify-end align-center py-2" style="width: 100%">
            <v-btn
              v-if="switchForm"
              class="mr-2 white--text"
              color="green"
              elevation="0"
              type="button"
              :loading="processing"
              :disabled="
                (v$.$invalid && v$.$errors.length > 0) ||
                (v$.$invalid && v$.$dirty) ||
                uploadErrors
              "
              @click="submit()"
            >
              {{ $t("register.steps.buttons.register") }}
              <v-icon class="ml-6">mdi-arrow-right</v-icon>
            </v-btn>
            <v-btn
              v-else
              class="mr-2 white--text"
              color="green"
              elevation="0"
              type="button"
              :loading="processing"
              :disabled="
                (v$.$invalid && v$.$errors.length > 0) ||
                (v$.$invalid && v$.$dirty) ||
                uploadErrors
              "
              @click="submit()"
            >
              {{ $t("register.steps.buttons.register") }}
              <v-icon class="ml-6">mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
      <pre>{{ v$ }}</pre>
    </v-slide-x-transition>
  </form>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import FileUpload from "@/interface/FileUpload.vue";
import moment from "moment";
// import DropZone from '../../interface/DropZone.vue'
export default {
  components: {
    // DropZone,
    FileUpload,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  props: {
    assets: {
      type: Object,
    },
    hash: {
      type: String,
    },
    country: {
      type: Number,
    },
    whitelabelCheckbox: {
      type: Boolean,
    },
  },
  mounted() {
    this.dateFormatted = moment().add(7, "days").format(this.formatDefault);
    this.switchForm = this.$route.params.p ? this.$route.params.p: ""
  },

  data: () => ({
    priceType: null,
    into: {
      whitelabel: false,
      saas: true,
      marketplace: true,
    },
    date: moment().add(7, "days").format("YYYY-MM-DD"),
    dateFormatted: null,
    menu1: false,
    touch: {
      midiaKit: false,
      priceTable: false,
    },
    switchForm: null,
    processing: false,
    loading: false,
    form: {
      frequency: "",
      info: "",
      files: {
        complementary: [],
        midiaKit: [],
        priceTable: [],
      },
      discount: null,
      //commission: null,
      tax: null,
      duedate: "",
      net: false,
      step: "uploadMaterial",
    },
  }),
  validations() {
    if (this.isBrazil)
      return {
        date: {
          required,
          minValue(val) {
            console.log("get", val);
            console.log("limit", moment().add(7, "days").format("X"));
            return (
              parseInt(moment(val, "YYYY-MM-DD").format("X")) >
              parseInt(moment().add(6, "days").format("X"))
            );
          },
        },
        form: {
          discount: { required },
          // commission: { required },
          frequency: { required },
        },
      };
    else
      return {
        date: {
          required,
          minValue(val) {
            console.log("get", val);
            console.log("limit", moment().add(7, "days").format("X"));
            return (
              parseInt(moment(val, "YYYY-MM-DD").format("X")) >
              parseInt(moment().add(6, "days").format("X"))
            );
          },
        },
        form: {
          discount: { required },
          // commission: { required },
          //tax: { required },
          frequency: { required },
        },
      };
  },
  computed: {
    formatDefault() {
      console.log("this.$i18n.locale", this.$i18n.locale);
      return this.$i18n.locale == "en" ? "MM/DD/YYYY" : "DD/MM/YYYY";
    },

    uploadErrors() {
      if (this.touch.midiaKit) {
        if (!this.form.files.midiaKit.length) return true;
      }
      if (this.touch.priceTable) {
        if (!this.form.files.priceTable.length) return true;
      }
      return false;
    },
    midiaKitErrors() {
      if (!this.touch.midiaKit) return null;
      if (!this.form.files.midiaKit.length)
        return this.$t("register.steps.inventory.errors.required.mediaKit");
      else return null;
    },
    priceTableErrors() {
      if (!this.touch.priceTable) return null;
      if (!this.form.files.priceTable.length)
        return this.$t("register.steps.inventory.errors.required.priceTable");
      else return null;
    },
    disableDays() {
      return moment().add(7, "days").format("YYYY-MM-DD");
    },
    isBrazil() {
      return this.assets.countries[this.country].code == "BRA";
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },

    dateErrors() {
      const errors = [];
      if (!this.v$.date.$dirty) return errors;
      this.v$.date.minValue.$invalid &&
        errors.push(
          this.$t("register.steps.inventory.errors.invalid.date", {
            date: moment().add(7, "days").format("DD/MM/YYYY"),
          })
        );
      this.v$.date.required.$invalid &&
        errors.push(this.$t("register.steps.inventory.errors.required.date"));
      return errors;
    },
    discountErrors() {
      const errors = [];
      if (!this.v$.form.discount.$dirty) return errors;
      this.v$.form.discount.required.$invalid &&
        errors.push(
          this.$t("register.steps.inventory.errors.required.discount")
        );
      return errors;
    },
    // commissionErrors() {
    //     const errors = [];
    //     if (!this.v$.form.commission.$dirty)
    //         return errors;
    //     this.v$.form.commission.required.$invalid && errors.push(this.$t('register.steps.inventory.errors.required.commission'))
    //     return errors;
    // },
    // taxErrors() {
    //   const errors = [];
    //   if (
    //     !this.v$.form.tax.$dirty ||
    //     this.assets.countries[this.country].code == "BRA"
    //   )
    //     return errors;
    //   this.v$.form.tax.required.$invalid &&
    //     errors.push(this.$t("register.steps.inventory.errors.required.tax"));
    //   return errors;
    // },
    frequencyErrors() {
      const errors = [];
      if (!this.v$.form.frequency.$dirty) return errors;
      this.v$.form.frequency.required.$invalid &&
        errors.push(
          this.$t("register.steps.inventory.errors.required.frequency")
        );
      return errors;
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    "$i18n.locale"() {
      this.dateFormatted = moment().add(7, "days").format(this.formatDefault);
    },
    "into.whitelabel"(val) {
      this.$emit("check-whitelabel", val);
    },
  },
  methods: {
    changeMidiaKit(e) {
      console.log("midia kit files uploaded", e);
      this.touch.midiaKit = true;
      this.form.files.midiaKit = e;
    },
    changePriceTable(e) {
      this.touch.priceTable = true;
      this.form.files.priceTable = e;
    },
    prevent(event) {
      event.stopPropagation();
    },
    formatDate(date) {
      if (!date) return null;

      return moment(date, "YYYY-MM-DD").format(this.formatDefault);
    },
    parseDate(date) {
      if (!date) return null;
      return moment(date, this.formatDefault).format("YYYY-MM-DD");
    },
    submit() {
      this.processing = true;
      this.v$.$touch();
      this.touch.midiaKit = true;
      this.touch.priceTable = true;
      if (!this.v$.$invalid && !this.priceTableErrors && !this.midiaKitErrors) {
        const Form = {
          comments: this.form.info,
          //commission: this.form.commission,
          discount: this.form.discount,
          expirationDate: this.date,
          frequency: this.frequency,
          whitelabel: this.into.whitelabel,
          files: {
            complementary: this.form.files.complementary,
            midiaKit: this.form.files.midiaKit,
            priceTable: this.form.files.priceTable,
          },
          //tax: this.form.tax,
          frequency: this.form.frequency,
          partner: this.$route.params.p ? this.$route.params.p: null,
          priceType: this.priceType
        };
        this.$axios
          .post(`portal/register/finish?hash=${this.hash}`, Form)
          .then(
            () => {
              this.confirmRegisterDone()
              // this.$emit("set-hash", {
              //   hash: this.hash,
              //   interaction: this.into.whitelabel
              //    ? "publisher.whitelabel"
              //    : "publisher.confirmlegal",
              // });
              // this.processing = false;
            },
            (err) => {
              const error = err.response.data.errors;
              console.error("ERR", error);
              if (error.length && error[0].hasOwnProperty("timeout")) {
                this.$emit("set-generic-error", {
                  text: this.$t("register.token.expired"),
                  show: true,
                });
              }
              this.processing = false;
            }
          );
      } else {
        this.processing = false;
      }
    },
    confirmRegisterDone(){
     return  this.$axios
                  .post(
                    `portal/register/confirm?hash=${this.hash}`,
                    {
                      partner:this.$route.params.p ? this.$route.params.p: null
                    }
                  )
                  .then(
                    (response) => {
                      console.log("confirmed", response);
                      this.$emit("set-hash", {
                        hash: this.hash,
                        interaction: "publisher.done",
                      });
                      this.processing = false;
                    },
                    (err) => {
                      const errors = JSON.parse(JSON.stringify(err));
                      alert(`Error: ${errors}`);
                      this.processing = false;
                    }
                  );
    }
  },
};
</script>
<style>
.v-btn--fab.v-size--x-small.xm-button {
  height: 20px;
  width: 20px;
}
</style>
